import React from 'react';

// Minimal stroke-style icon set for craft recipe categories - simple
// geometric glyphs (not licensed artwork), same convention as
// professionsMenu/icons.tsx: 24x24 viewBox / currentColor so they inherit
// whatever gold/cream color the surrounding UI applies.
const base = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export const CATEGORY_ICON: Record<string, JSX.Element> = {
  ingot: (
    <svg {...base}><path d="M5 9h14l-2 8H7z" /><path d="M5 9 7 5h10l2 4" /></svg>
  ),
  hide: (
    <svg {...base}><path d="M12 3c4 1 7 4 7 8 0 5-3 8-7 10-4-2-7-5-7-10 0-4 3-7 7-8Z" /></svg>
  ),
  food: (
    <svg {...base}><path d="M5 10h14l-1.2 9a2 2 0 0 1-2 1.7H8.2a2 2 0 0 1-2-1.7z" /><path d="M3 10h18" /><path d="M9 10V8a3 3 0 0 1 6 0v2" /></svg>
  ),
  weapon: (
    <svg {...base}><path d="M12 2v14" /><path d="M8 6h8" /><path d="M12 16l-3 5" /><path d="M12 16l3 5" /></svg>
  ),
  armor: (
    <svg {...base}><path d="M12 3l7 3v6c0 5-3 7.5-7 9-4-1.5-7-4-7-9V6z" /></svg>
  ),
  tool: (
    <svg {...base}><path d="M14.5 3a4 4 0 0 0-3.7 5.5L4 15.3V20h4.7l6.8-6.8A4 4 0 0 0 21 9.5 4 4 0 0 0 14.5 3Z" /></svg>
  ),
  potion: (
    <svg {...base}><path d="M9 3h6" /><path d="M10 3v5l-4.5 8.5A2.5 2.5 0 0 0 7.7 20h8.6a2.5 2.5 0 0 0 2.2-3.5L14 8V3" /><path d="M7.5 15h9" /></svg>
  ),
  poison: (
    <svg {...base}><path d="M9 3h6" /><path d="M10 3v5l-4.5 8.5A2.5 2.5 0 0 0 7.7 20h8.6a2.5 2.5 0 0 0 2.2-3.5L14 8V3" /><circle cx="10.5" cy="15" r="0.8" /><circle cx="13.5" cy="16.5" r="0.8" /></svg>
  ),
  ammo: (
    <svg {...base}><path d="M5 19 19 5" /><path d="M15 5h4v4" /><path d="M5 19l-1-3" /><path d="M5 19l3 1" /></svg>
  ),
  jewelry: (
    <svg {...base}><circle cx="12" cy="14" r="5" /><path d="M9.5 6.5 12 3l2.5 3.5-2.5 2z" /></svg>
  ),
  construction: (
    <svg {...base}><path d="M3 20h18" /><path d="M5 20V10l7-6 7 6v10" /><path d="M10 20v-6h4v6" /></svg>
  ),
};

export function categoryIcon(category: string): JSX.Element {
  return CATEGORY_ICON[category] ?? CATEGORY_ICON.ingot;
}
